import { AxiosError } from 'axios';
import { ConfigurationType } from 'web-library/models/DropDown';
import { EXPORT_JOB_STATUS_REPORT_URL } from '../../constants/apiUrls';
import { JobNameModel } from '../../models/JobName';
import axiosClient from '../axiosClient';
import {GenericErrorResponse, UuidModel} from '../typings';
import { useCustomMutation } from '../utils/useCustomMutation';

// =============================================================================
// Request & Response Model
// ============================================================================
export interface ExportJobStatusReportPayload {
  jobName: JobNameModel;
  startDate: string;
  endDate: string;
  q: string | null;
  recordStatus: Pick<ConfigurationType, 'code'> | null;
  examLevels: Pick<ConfigurationType, 'code'>[] | null;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: UuidModel) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostExportJobStatusReport = ({ onSuccess, onError }: Input = {}) => {
  const postExportJobStatusReport = async (requestBody: ExportJobStatusReportPayload) => {
    const res = await axiosClient.post<UuidModel>(EXPORT_JOB_STATUS_REPORT_URL, requestBody);
    return res.data;
  };

  return useCustomMutation(postExportJobStatusReport, {
    onSuccess,
    onError,
  });
};
